export default Object.freeze({
  MMddyyyySlash: 'MM/dd/yyyy',
  MMddyyyyDash: 'MM-dd-yyyy',
  yyyyMMddSlash: 'yyyy/MM/dd',
  yyyyMMddDash: 'yyyy-MM-dd',
  yyyyMMdd: 'yyyyMMdd',
})



// WEBPACK FOOTER //
// ./src/models/DateFormat.js